import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Cartonization.frontend.types'

@Injectable({ providedIn: 'root' })
export class Cartonization_strategy_three_dimensional_fitting_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { quantities?: { orderId?: number, lineNumber?: number, materialId?: number, packagingId?: number, amount?: number }[], containerTypeIds?: number[] }): Promise<{ containers?: any[], uncartonizedQuantities?: { orderId?: number, lineNumber?: number, materialId?: number, packagingId?: number, amount?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Cartonization/functions/strategy_three_dimensional_fitting_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

